import React, { useState } from 'react'
import './ContactSupport.css'
import { RiCustomerService2Fill } from 'react-icons/ri'
import { BsTelegram, BsWhatsapp, BsInstagram } from 'react-icons/bs'
import { BiSolidPhoneCall } from 'react-icons/bi'
export default function ContactSupport() {
    const [ShowSupportSidebar, setShowSupportSidebar] = useState(false)
    return (
        <>
            <div className='Contact-support' onClick={() => setShowSupportSidebar(!ShowSupportSidebar)}>
                <RiCustomerService2Fill />
            </div>
            <div className={`support-sidebar ${ShowSupportSidebar ? 'active' : ''}`}>
                <ul>
                    <li>
                        تماس با ما
                        <BiSolidPhoneCall />
                    </li>
                    <li>
                        <a href="https://wa.me/+989203693646">
                            ارتباط در واتساپ
                        </a>
                        <BsWhatsapp />
                    </li>
                    <li>
                        <a href="https://t.me/+989203693646">
                            ارتباط در تلگرام
                        </a>
                        <BsTelegram />
                    </li>
                    <li>
                        <a href="https://www.instagram.com/senik.co">
                            ارتباط در اینستاگرام
                        </a>
                        <BsInstagram />
                    </li>
                </ul>
            </div>
        </>


    )
}
